import React from "react";
import { useNavigate } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {formatDate, parseTags} from "utils/format";
import {ThunkDispatch} from "@reduxjs/toolkit";
import {
  setChatSelected, setIsSameChatSelected, 
  setIsChatting, setIsPaging, 
  setIsScout, setStaffSelected,
  setMessages, setIsLoadNewListChat,
  setJobSelected, setOpenChatListModal,
  getTalentMessages, setIsNewChatFormOtherScreen,
} from "reducers/chatMessage";
import {setCanBackPrevPage} from "reducers/talentHome";


interface ContentItemProps {
  content: any;
}
const ContentItem: React.FC<ContentItemProps> = ({ content }) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();

  const goToDetail = (item: any) => {
    switch(item?.type) {
        case 'news':
          dispatch(setCanBackPrevPage(true));
          navigate("/talent/news/" + item.id)
          break;
        case 'job':
          dispatch(setCanBackPrevPage(true));
          navigate("/talent/job/detail/" + item.id)
          break;
        case 'chat':
          dispatch(setOpenChatListModal(true));
          dispatch(setIsSameChatSelected(true));
          dispatch(setMessages([]));
          dispatch(setChatSelected({}));
          dispatch(setStaffSelected({}));
          dispatch(setJobSelected({}));
          dispatch(setIsPaging(false));
          dispatch(setIsLoadNewListChat(true));
          dispatch(setIsNewChatFormOtherScreen(false));
          navigate('/talent/message')
          break;
        default:
          break;
    }
  };

  return (
    <div className="py-2 flex flex-col gap-1 md:gap-2 border-b border-[#E0E0E0]">
      <p className="text-sm leading-[1.3125rem] alu-text-base-2">
        {formatDate(content.public_date)}
      </p>
      <div className="flex flex-wrap items-center gap-1">
        <div
          className={`shrink-0 py-[0.125rem] px-2 ${content.type != 'chat' ? 'bg-cus-primary' : 'bg-cus-danger'} font-bold leading-[1.125rem] text-xs text-white rounded`}
        >
          {content.label}
        </div>
        {content.tags && parseTags(content.tags).map((tag: any, idx: any) => (
            <span
              key={idx}
              className="shrink-0 py-[0.125rem] px-[0.375rem] rounded border border-[#808080] bg-white text-[#808080] font-bold leading-[1.125rem] text-xs"
            >
              {tag}
            </span>
          ))
        }
      </div>
      <h5 onClick={() => goToDetail(content)} className="xl:block hidden font-bold text-base alu-text-base-2 hover:cursor-pointer hover:text-[#FF861A] w-fit break-words break-all line-clamp-1">
        {content.title}
      </h5>
      <h5 onClick={() => goToDetail(content)} className="xl:hidden font-bold text-base alu-text-base-2 w-fit break-words break-all line-clamp-1">
        {content.title}
      </h5>
    </div>
  );
};

const ContentNotification = () => {
  const { notifications } = useSelector((state: any) => state.talentHome);

  return (
    <>
      <div className="p-4 bg-white rounded-2xl alu-section-box-shadow">
        {notifications.map((content: any, idx: any) => (
          <ContentItem key={idx} content={content} />
        ))}
      </div>
    </>
  );
};

export default ContentNotification;
